// extracted by mini-css-extract-plugin
export default {"light":"StatusLight_light__7yfDI","valid":"StatusLight_valid__a2kvv","unhandled":"StatusLight_unhandled__3oAW-","invalid":"StatusLight_invalid__te+ez"};